import React from 'react'

import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL, // Keycloak base URL
  realm: process.env.REACT_APP_KEYCLOAK_REALM, // Replace with your realm name
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT, // Replace with your client ID
  cors:true
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak


// import Keycloak from "keycloak-js";
// import { useEffect } from "react";

// const keycloak = new Keycloak({
//   url: "http://localhost:8080/",
//   realm: "myrealm",
//   clientId: "myclient",
// });

// const KeycloakProvider = ({ children }) => {
//   useEffect(() => {
//     // Initialize Keycloak
//     keycloak
//       .init({
//         onLoad: "login-required",
//         checkLoginIframe: false,
//       })
//       .then((authenticated) => {
//         if (authenticated) {
//           // Store the initial token in sessionStorage
//           sessionStorage.setItem("accessToken", keycloak.token);

//           // Set up a token refresh interval
//           const refreshInterval = setInterval(() => {
//             keycloak
//               .updateToken(30) // Refresh token if it's within 30 seconds of expiring
//               .then((refreshed) => {
//                 if (refreshed) {
//                   console.log("Token refreshed");
//                   sessionStorage.setItem("accessToken", keycloak.token);
//                 } else {
//                   console.warn("Token not refreshed, valid for now");
//                 }
//               })
//               .catch(() => {
//                 console.error("Failed to refresh token");
//                 clearInterval(refreshInterval);
//                 keycloak.logout(); // Log out if token refresh fails
//               });
//           }, 60000); // Check every minute (adjust based on token TTL)

//           return () => clearInterval(refreshInterval); // Clean up interval on unmount
//         } else {
//           console.warn("User is not authenticated");
//         }
//       })
//       .catch((error) => {
//         console.error("Keycloak initialization failed:", error);
//       });
//   }, []);

//   return <>{children}</>;
// };

// export default KeycloakProvider;

